// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__10iXQ","left":"StickyBox_left__1AIGq","right":"StickyBox_right__2BxbQ"};